module.exports = __webpack_public_path__ + "src/app/_content/imgs/bmw/id_module/id.png?8fc10ae657c702336dc593a73ca4a83d";